import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=5a871332&scoped=true"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatingButtons.vue?vue&type=style&index=0&id=5a871332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a871332",
  null
  
)

export default component.exports